/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import {
  ANALYTICS_ACTION_ERROR,
  ANALYTICS_ACTION_SUCCESS,
  ANALYTICS_PAGE_LOAD,
  ANALYTICS_PAGE_OVERLAY_LOAD
} from 'state/analytics/AnalyticsActions';

/**
 * @param {String} pageName - Pipe delimited String containing 1 to 4 items representing
 * the hierarchy and name of the page within the given application.
 */
const dispatchPageLoad = (pageName) => {
  try {
    // instantiate a CustomEvent with an eventType of “pageLoad”
    const event = new CustomEvent('pageLoad', {
      detail: {
        page: pageName
      }
    });

    window.dispatchEvent(event);
  } catch (e) {
    //eslint-disable-no-empty
  }
};

/**
 * @param {String} error - String representing the error within the given page.
 */
const dispatchErrorLoad = (error) => {
  try {
    // instantiate a CustomEvent with an eventType of “errorLoad”
    const event = new CustomEvent('errorLoad', {
      detail: {
        error: error
      }
    });

    document.body.dispatchEvent(event);
  } catch (e) {
    //eslint-disable-no-empty
  }
};

/**
 * @param {String} action - Pipe delimited String representing the type and name
 * of the Action being of the Completed.
 */
const dispatchActionComplete = (action) => {
  try {
    // instantiate a CustomEvent with an eventType of “actionComplete”
    const event = new CustomEvent('actionComplete', {
      detail: {
        action: action
      }
    });

    document.body.dispatchEvent(event);
  } catch (e) {
    //eslint-disable-no-empty
  }
};

/**
 * Function for instantiating and dispatching a JavaScript CustomEvent for
 * signaling that an overlay has loaded within a given page.
 *
 * @param {String} overlay - String representing the name of the overlay
 * being loaded within the given page.
 */

export const dispatchOverlayLoad = (overlay) => {
  try {
    // instantiate a CustomEvent with an eventType of “overlayLoad”
    var event = new CustomEvent("overlayLoad", {
      detail: {
        // set the value of the function’s overlay parameter to
// an “overlay” property on the CustomEvent’s detail object
        overlay: overlay
      }
    });
    // dispatch the CustomEvent from the body
    document.body.dispatchEvent(event);
  } catch(e) {
    // handle exceptions as needed
  }
}


const AnalyticsLogic = createLogic({
  type: [ANALYTICS_ACTION_ERROR, ANALYTICS_ACTION_SUCCESS, ANALYTICS_PAGE_LOAD, ANALYTICS_PAGE_OVERLAY_LOAD],

  process({ action }, dispatch, done) {
    if (action.type === ANALYTICS_ACTION_ERROR) {
      try {
        dispatchErrorLoad(action.message);
      } catch (e) {
        //eslint-disable-no-empty
      }
    }

    if (action.type === ANALYTICS_ACTION_SUCCESS) {
      try {
        dispatchActionComplete(action.action);
      } catch (e) {
        //eslint-disable-no-empty
      }
    }

    if (action.type === ANALYTICS_PAGE_LOAD) {
      try {
        dispatchPageLoad(action.page);
      } catch (e) {
        //eslint-disable-no-empty
      }
    }

    if (action.type === ANALYTICS_PAGE_OVERLAY_LOAD) {
      try {
        dispatchOverlayLoad(action.overlay);
      } catch (e) {
        //eslint-disable-no-empty
      }
    }

    done();
  }
});

export default AnalyticsLogic;
